import { render, staticRenderFns } from "./TimeStatsWidget.vue?vue&type=template&id=e73109ee&scoped=true&"
import script from "./TimeStatsWidget.ts?vue&type=script&lang=ts&"
export * from "./TimeStatsWidget.ts?vue&type=script&lang=ts&"
import style0 from "./TimeStatsWidget.vue?vue&type=style&index=0&id=e73109ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73109ee",
  null
  
)

export default component.exports